class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', this.onMobileUpsellToggle.bind(this));
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    const iconsearch = document.querySelector(".header__search");
    if (iconsearch)
      iconsearch.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    const iconaccount = document.querySelector(".header__icon--account");
    if (iconaccount)
      iconaccount.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    this.stickyHeaderAvailable = document.querySelector('sticky-header') ? true : false;

  }

  connectedCallback(){
    let stickyHeaderHeight = 0;
    document.querySelectorAll('.section-header').forEach(ele =>{
      stickyHeaderHeight += ele.getBoundingClientRect().height;
    });
    let headerHeight = stickyHeaderHeight;
    document.querySelectorAll('.utility-bar').forEach(ele =>{
      headerHeight += ele.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--header-announce-height', headerHeight+'px');
    document.documentElement.style.setProperty('--header-sticky-height', stickyHeaderHeight+'px');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.contains("active") ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // if(!this.stickyHeaderAvailable){
    //   window.scrollTo(0, 0);
    // }
    const wasAlreadyOpen = this.classList.contains('active');
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    if (wasAlreadyOpen) {
      this.restoreCartDrawerReview();
    } else {
      this.rotateCartDrawerReview();
    }
    this.restoreMobileUpsellState();
    if (!this.__tfgSkipDiscountRefresh) {
      window.tfgRefreshCartDrawerWithActiveDiscount?.();
    }
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden-drawer');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden-drawer');
  }

  rotateCartDrawerReview() {
    const reviewItems = this.querySelectorAll('[data-cart-drawer-review]');
    if (!reviewItems.length) return;

    const storageKey = 'cartDrawerReviewIndex';
    let nextIndex = 0;

    try {
      const previousIndex = Number(window.sessionStorage.getItem(storageKey));
      nextIndex = Number.isNaN(previousIndex) ? 0 : (previousIndex + 1) % reviewItems.length;
      window.sessionStorage.setItem(storageKey, String(nextIndex));
    } catch (error) {
      const currentIndex = Array.from(reviewItems).findIndex((item) => item.classList.contains('is-active'));
      nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % reviewItems.length;
    }

    this.setCartDrawerReview(nextIndex, reviewItems);
  }

  restoreCartDrawerReview() {
    const reviewItems = this.querySelectorAll('[data-cart-drawer-review]');
    if (!reviewItems.length) return;

    let currentIndex = 0;

    try {
      const storedIndex = Number(window.sessionStorage.getItem('cartDrawerReviewIndex'));
      currentIndex = Number.isNaN(storedIndex) ? 0 : storedIndex % reviewItems.length;
    } catch (error) {
      currentIndex = Array.from(reviewItems).findIndex((item) => item.classList.contains('is-active'));
      if (currentIndex < 0) currentIndex = 0;
    }

    this.setCartDrawerReview(currentIndex, reviewItems);
  }

  setCartDrawerReview(activeIndex, reviewItems = this.querySelectorAll('[data-cart-drawer-review]')) {
    reviewItems.forEach((item, index) => {
      item.classList.toggle('is-active', index === activeIndex);
    });
  }

  onMobileUpsellToggle(event) {
    const upsell = event.target.closest('.cart-drawer-mobile-upsell');
    if (!upsell) return;

    const toggle = event.target.closest('[data-mobile-upsell-toggle]');
    if (toggle) {
      event.preventDefault();
      this.setMobileUpsellCollapsed(upsell, !upsell.classList.contains('is-collapsed'));
      return;
    }

    const heading = event.target.closest('[data-mobile-upsell-heading]');
    if (heading && upsell.classList.contains('is-collapsed')) {
      event.preventDefault();
      this.setMobileUpsellCollapsed(upsell, false);
    }
  }

  restoreMobileUpsellState() {
    let shouldCollapse = false;

    try {
      shouldCollapse = window.sessionStorage.getItem('cartDrawerMobileUpsellCollapsed') === 'true';
    } catch (error) {
      shouldCollapse = false;
    }

    this.querySelectorAll('.cart-drawer-mobile-upsell').forEach((upsell) => {
      this.setMobileUpsellCollapsed(upsell, shouldCollapse, false);
    });
  }

  setMobileUpsellCollapsed(upsell, shouldCollapse, shouldStore = true) {
    upsell.classList.toggle('is-collapsed', shouldCollapse);

    const toggle = upsell.querySelector('[data-mobile-upsell-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(!shouldCollapse));
      toggle.setAttribute(
        'aria-label',
        shouldCollapse ? 'Expand recommended products' : 'Collapse recommended products'
      );
    }

    if (!shouldStore) return;

    try {
      window.sessionStorage.setItem('cartDrawerMobileUpsellCollapsed', String(shouldCollapse));
    } catch (error) {
      // Ignore storage errors; the visual state has already updated.
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    const shouldWaitForUpsellExit = this.animateUpsellExit(parsedState.sections['cart-drawer']);
    const renderUpdatedSections = () => {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    };

    if (shouldWaitForUpsellExit) {
      setTimeout(renderUpdatedSections, 300);
    } else {
      renderUpdatedSections();
    }
  }

  animateUpsellExit(nextCartDrawerHtml) {
    if (!this.classList.contains('active') || !nextCartDrawerHtml) return false;

    const currentDrawer = document.getElementById('CartDrawer');
    const nextDrawer = new DOMParser().parseFromString(nextCartDrawerHtml, 'text/html');
    let shouldWait = false;

    const currentDesktopUpsell = currentDrawer?.querySelector('.drawer_tab--upsell.active');
    const nextDesktopUpsell = nextDrawer.querySelector('.drawer_tab--upsell');
    if (currentDesktopUpsell && !nextDesktopUpsell) {
      currentDesktopUpsell.classList.remove('active');
      shouldWait = true;
    }

    const currentMobileUpsell = currentDrawer?.querySelector('.cart-drawer-mobile-upsell');
    const nextMobileUpsell = nextDrawer.querySelector('.cart-drawer-mobile-upsell');
    if (currentMobileUpsell && !nextMobileUpsell) {
      currentMobileUpsell.classList.add('cart-drawer-mobile-upsell--closing');
      shouldWait = true;
    }

    return shouldWait;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
